
import Vue, { PropType } from "vue";

export default Vue.extend({
  props: {
    tabs: Array as PropType<
      {
        label: string;
        route: string;
        id: string;
      }[]
    >,
  },
  data() {
    return {
      tab: null,
    };
  },
});
